<template>
  <div class="panel network-resource-nav">
    <div class="panel-title">网格基础资源管理 <small>统一维护基础网格地图、网格人员档案和岗位信息，供网格案例选用</small></div>
    <nav class="inline-actions" aria-label="网格基础资源管理">
      <router-link class="btn" :class="{ primary: ['map-templates', 'map-template-detail'].includes($route.name) }" to="/map-templates">基础网格地图配置</router-link>
      <router-link class="btn" :class="{ primary: $route.name === 'personnel' }" to="/personnel">网格人员档案</router-link>
      <router-link class="btn" :class="{ primary: $route.name === 'role-standards' }" to="/role-standards">岗位信息配置</router-link>
    </nav>
  </div>
</template>

<script>
export default { name: 'NetworkResourceNav' }
</script>
